import React, { useState, useEffect } from 'react';
import Layout from 'components/Layout';
import ValidSession from 'components/ValidSession';
import Salutation from 'components/Salutation';
import AccountTabs from 'components/AccountTabs';
import SessionFactory from 'factories/Session';
import { main_links } from 'config';
import ContentTerminosPolitica from 'components/ContentTerminosPolitica';

const Privacy = () => {

    const [loadData, setLoadData] = useState(false);
    const [dataPage, setDataPage] = useState({});
    useEffect(() => {
        const sessValid = SessionFactory.validation()
        setDataPage({ session: sessValid });
        setLoadData(true);
    }, []);

    return (
        <div className="mi-cuenta cupones is-logged">
            {loadData && <ValidSession dataSession={dataPage.session && dataPage.session}/>}
            <Layout dataPage={dataPage} showContent={loadData && dataPage.session? true : false} showBanner={false}>
                <Salutation sessionData={dataPage.session}/>
                <section className="my-account">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-3 mt-4 left-menu">
                                <AccountTabs currentPath={main_links.privacy}/>
                            </div>
                            <div className="col-12 col-lg-9 mt-4">
                                <div className="border">
                                    <div className="row">
                                        <div className="col-12 text-content">
                                            <ContentTerminosPolitica typeContent="politica" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <br /><br /><br />
                                <br /><br /><br />
                                <br /><br /><br />
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
};

export default Privacy;